import { useState } from "react";
import { request } from "../../../request";
import CreatableSelect from "react-select/creatable";
import Swal from "sweetalert2";

const AddCustomer = ({ customerType, updateCustomers, darkMode, texts }) => {
    const [customerName, setCustomerName] = useState("");
    const [customerContact, setCustomerContact] = useState("");
    const [customerComment, setCustomerComment] = useState("");
    const [selectedCustomerType, setSelectedCustomerType] = useState("");

    const createCustomerType = async (newType) => {
        const label = newType ? newType : null;
        setSelectedCustomerType(label);
        await request.post("/customer/type", {
            type: newType,
        });
        updateCustomers();
    };

    const handleSubmit = async () => {
        try {
            await request.post("/customer", {
                name: customerName,
                contact: customerContact,
                comment: customerComment,
                type: selectedCustomerType,
            });
            Swal.fire({
                title: "Customer added successfully",
                icon: "success",
            });
            setCustomerContact("");
            setCustomerName("");
            setCustomerComment("");
            setSelectedCustomerType("");
            updateCustomers();
        } catch (error) {
            Swal.fire({
                title: "Customer hasen't been added",
                icon: "error",
            });
            console.log(error);
        }
    };

    const options = customerType.map((option) => ({
        value: option._id,
        label: option.type,
    }));

    return (
        <div>
            <div
                className="container p-6 mx-auto max-w-[900px] border-gray-300 rounded-lg shadow-lg"
                style={{
                    backgroundColor: darkMode ? "#000" : "white",
                    borderRadius: "20px",
                }}
            >
                <form className="mb-4" onSubmit={handleSubmit}>
                    <div className="flex flex-col mb-4">
                        <label
                            className="text-lg mb-2"
                            htmlFor="name"
                            style={{
                                color: darkMode ? "white" : "black",
                            }}
                        >
                            {texts.customer.customerName}
                        </label>
                        <input
                            type="text"
                            id="name"
                            value={customerName}
                            onChange={(e) => {
                                const value = e.target.value;
                                const filteredValue = value.replace(/[^a-zA-Z0-9 ]/g, ''); 
                                setCustomerName(filteredValue);
                            }}
                            className="border p-2 rounded"
                            placeholder={texts.customer.enterCustomerName}
                            required
                        />
                    </div>
                    <div className="flex flex-col mb-4">
                        <label
                            className="text-lg mb-2"
                            htmlFor="value"
                            style={{
                                color: darkMode ? "white" : "black",
                            }}
                        >
                            {texts.customer.customerContact}
                        </label>
                        <input type="text" id="contact" value={customerContact} onChange={(e) => setCustomerContact(e.target.value)} className="border p-2 rounded" placeholder={texts.customer.enterCustomerContact} required />
                    </div>
                    <div className="flex flex-col mb-4">
                        <label
                            className="text-lg mb-2"
                            htmlFor="name"
                            style={{
                                color: darkMode ? "white" : "black",
                            }}
                        >
                            {texts.customer.addComment}
                        </label>
                        <input type="text" id="comment" value={customerComment} onChange={(e) => setCustomerComment(e.target.value)} className="border p-2 rounded" placeholder={texts.customer.enterComment} />
                    </div>
                    <CreatableSelect
                        isClearable
                        options={options}
                        onChange={(selectedOption) => {
                            const label = selectedOption ? selectedOption.label : null;
                            setSelectedCustomerType(label);
                        }}
                        onCreateOption={(newOption) => {
                            createCustomerType(newOption);
                        }}
                        value={selectedCustomerType ? { label: selectedCustomerType, value: selectedCustomerType } : ""}
                        styles={{
                            control: (base) => ({
                                ...base,
                                borderColor: "gray",
                                borderRadius: "0.375rem",
                                padding: "0.375rem",
                                boxShadow: "none",
                                "&:hover": { borderColor: "blue" },
                            }),
                            option: (base, state) => ({
                                ...base,
                                backgroundColor: state.isSelected ? "blue" : state.isFocused ? "lightgray" : "white",
                                color: state.isSelected ? "white" : "black",
                                "&:hover": {
                                    backgroundColor: "lightblue",
                                },
                            }),
                            menu: (base) => ({
                                ...base,
                                marginTop: 0,
                                borderRadius: "0.375rem",
                            }),
                            placeholder: (base) => ({
                                ...base,
                                color: "gray",
                                fontSize: "0.875rem",
                            }),
                        }}
                        placeholder={texts.customer.selectOrCreateUserType}
                    />
                    <button
                        type="submit"
                        className="flex min-w-[84px] max-w-[480px] mt-4 cursor-pointer items-center justify-center overflow-hidden rounded-xl h-10 px-4 bg-gray-200 text-[#111418] text-sm font-bold leading-normal tracking-[0.015em]"
                        style={{
                            backgroundColor: darkMode ? "#FEC901" : "#FEC901",
                        }}
                    >
                        {texts.customer.addUser}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AddCustomer;
